<template>
  <div></div>
</template>

<script>
import {setToken} from '@/utils/auth'
import { setPageRouter } from "@/utils/pageRouter";
import { mapActions } from 'vuex';
import { weChat, getQueryString } from "@/utils/ruoyi";
import { qywxOauthUrl } from '@/api/login'
export default {
  created() {
    this.init();
  },
  methods: {
    ...mapActions(['QyWxLogin', 'GetInfo']),
    init() {
      if (weChat() === "wxwork") {
        // 企业微信单点登录
        if (getQueryString('code') && getQueryString("state")) {
          this.QyWxLogin({code: getQueryString('code')})
            .then(res => {
              this.GetInfo().then(() => {
                if (getQueryString('menu_info')) {
                  this.$router.replace(setPageRouter().toUrl || "/");
                } else {
                  this.$router.replace("/");
                }
              }).catch(err => {
                this.$router.replace("/");
              })
            }).catch( () => {
              this.$message.error("授权失败");
              this.$router.replace("/");
            })
        } else {
          // let oauthCallBack = encodeURI(
          //   window.location.protocol +
          //     "//" +
          //     window.location.host +
          //     "/authorization"
          // );
          let oauthCallBack = encodeURI(window.location.href);
          qywxOauthUrl({ oauth_callback: oauthCallBack })
            .then((res) => {
              window.location.replace(res.data.oauth_url);
            })
            .catch(() => {
              this.$message.error("授权失败");
              this.$router.replace("/");
            });
        }
      } else {
        // 其他登录
        this.$router.replace("/index");
      }
    },
  },
};
</script>